// extracted by css-extract-rspack-plugin
export default {"footer":"src-app-components-layout-TabLayout-TabLayout-module__footer-RRAYet","screen":"src-app-components-layout-TabLayout-TabLayout-module__screen-viy0IE"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"footer\":\"src-app-components-layout-TabLayout-TabLayout-module__footer-RRAYet\",\"screen\":\"src-app-components-layout-TabLayout-TabLayout-module__screen-viy0IE\"}";
        // 1789362522814
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  